// Function to calculate the time difference between check-in and check-out in hours and minutes

export function calculateTimeDifference(checkInTime, checkOutTime, stayHrs, stayMins) {
  console.log('checkInTime', checkInTime);

  const diffInMs = new Date(checkOutTime) - new Date(checkInTime);
  const diffInHr = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInMin = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  // Converting minutes to to hours: divide by 60
  // To convert the remaining minutes: mod by 60
  stayHrs = diffInHr;
  stayMins = diffInMin;
  const diff = `${diffInHr} Hrs ${diffInMin} Mins`;
  console.log('Time difference:', diff, stayHrs, stayMins);
  return { timeDiff: diff, hours: stayHrs, minutes: stayMins };
}

export function convertToDatabaseDateTime(dateObj) {
  const date = new Date(dateObj);
  const databaseDateTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  console.log('Database DateTime:', databaseDateTime);
  return databaseDateTime;
}

// Function to add hour headers from 0 to 23
export function addHoursHeaders(ref) {
  const headers = [];
  for (let i = 0; i <= 23; i++) {
    // Add table header for each hour
    ref.push(i);
    if (i > 12) {
      headers.push(`${i - 12}P`);
    } else if (i === 12) {
      headers.push(`${i}P`);
    } else if (i === 0) {
      headers.push(`${i + 12}A`);
    } else {
      headers.push(`${i}A`);
    }
  }

  return headers;
}
// Function that list dates between two dates
export function getDatesInRange(start, end) {
  const dates = [];
  for (let i = new Date(start); i <= new Date(end); i.setDate(i.getDate() + 1)) {
    dates.push(new Date(i).toISOString().split('T')[0]);
  }

  return dates;
}

// Function to format date to YYYY-MM-DD
export function formatDate(date) {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
}

export const normalizeDate = (date) => {
  console.log('normalizeDate date', date);
  return new Date(date).toISOString().split(0, 10);
};

export //This is how to format date from MM/DD/YYYY to YYYY-MM-DD
const formatDateToDB_Format = (date) => {
  const [year, month, day] = date.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
